import { IBookingCalendarStore } from '../index'

export default function(state: IBookingCalendarStore): IBookingCalendarStore {
  return {
    ...state,
    roomModal: {
      ...state.roomModal,
      createForm: {
        ...state.roomModal.createForm,
        isOpen: !state.roomModal.createForm.isOpen,
      },
    },
  }
}
